import React, { useState } from 'react';
import { LatLongIcon, MarkerIcon } from '@rsos/assets/icons';
import HoveredButton from '@rsos/components/capstone/HoveredButton';
import usePortalType from '@rsos/utils/usePortalType';
import { handleCopy } from '../helpers/handleCopy';
import {
  CopyRowBox,
  LeftText,
  MiddleText,
  RowBox,
  IconWrapper,
} from '../styles/common.styles';

const LatLong = ({
  longitude,
  latitude,
  isHoverable,
  irpVersion,
  w3w,
  payloadID,
  requestID,
}) => {
  const [isCopied, setIsCopied] = useState();
  const { portalType } = usePortalType();
  const onClick = () => {
    handleCopy({
      value: `${latitude}, ${longitude}`,
      name: 'Lat and Long',
      irpVersion,
      payloadID,
      requestID,
      onStart: () => {
        setIsCopied(true);
      },
      onEnd: () => {
        setIsCopied(false);
      },
      portalType,
    });
  };

  return (
    <RowBox br="5px" isHoverable={isHoverable} copied={isCopied}>
      <RowBox>
        <IconWrapper>
          {w3w ? (
            <MarkerIcon width={16} height={25} color="#FF6969" />
          ) : (
            <LatLongIcon />
          )}
        </IconWrapper>
        <CopyRowBox data-name="location-lat-long">
          <LeftText>Lat/Long:&nbsp;</LeftText>
          <MiddleText data-name="location-lat-long-text">
            {parseFloat(latitude).toFixed(5)},&nbsp;
            {parseFloat(longitude).toFixed(5)}
          </MiddleText>
        </CopyRowBox>
      </RowBox>
      {isHoverable && (
        <HoveredButton onClick={onClick} withIcon isCopied={isCopied} />
      )}
    </RowBox>
  );
};

export default LatLong;
